// Shared value formatters for the AI Credit report screens (super-admin + client).
// Kept as a mixin so the date helpers can reach the global `formatDate` filter
// via `this` — Vue 2 filters can't be used inside ternaries/expressions.
export default {
  methods: {
    // Thousands-separated integer, 0 for null/NaN.
    formatNum(v) {
      return Number(v || 0).toLocaleString();
    },
    // Global formatDate filter as a method; "-" for empty.
    fmtDate(v) {
      return v ? this.$options.filters.formatDate(v) : "-";
    },
    // "DD-MMM-YYYY | HH:mm:ss"; "-" for empty.
    fmtDateTime(v) {
      if (!v) return "-";
      const d = new Date(v);
      const p = (n) => String(n).padStart(2, "0");
      return `${this.$options.filters.formatDate(v)} | ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    },
  },
};
